import { makeStyles } from 'lib/components';

export default makeStyles({
  mapPin: {
    position: 'absolute',
    bottom: '50%',
    left: '50%',
    transform: 'translateX(-50%)',
    filter: 'drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 18px rgba(0, 0, 0, 0.12)) drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.2))',
  },
  pinContent: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    minWidth: '52px',
    height: '52px',
    padding: '4px',
    background: '#FFFFFF',
    borderRadius: '25px',
    fontFamily: '"Helvetica"',
  },
  numberDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: '13px',
    padding: '0 10px',
    minWidth: '44px',
    height: '44px',
    background: ({ pinIndex, colors }) => colors[pinIndex % colors.length],
    borderRadius: '22px',
    color: '#FFFFFF',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '15px',
  },
  addressDiv: {
    maxWidth: '0',
    height: 'fit-content',
    margin: ({ hasDeleteButton }) => (hasDeleteButton ? '0 2.5px' : 0),
    transition: 'all 1s, margin 500ms',
    overflow: 'hidden',
    '&[hovered=true],&.focused': {
      maxWidth: '300px !important',
      margin: '0 10px !important',
    },
  },
  addressText: {
    fontSize: '14px',
    textOverflow: 'clip',
    fontWeight: 400,
    lineHeight: '17px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: '#1B202C',
    whiteSpace: 'nowrap',
    '& >strong': {
      fontWeight: 700,
    },
  },
  addressDeleteBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 13px',
    width: '35px',
    height: '35px',
    background: '#E4E4E4',
    borderRadius: '20px',
    color: '#FFFFFF',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '15px',
    minWidth: 'unset',
  },
  arrow: {
    width: '26px',
    boxSizing: 'border-box',
    background: 'transparent',
    borderLeft: '13px solid transparent',
    borderRight: '13px solid transparent',
    borderTop: '20px solid #FFFFFF',
    margin: '0 auto',
    marginTop: '-10.5px',
  },
  point: {
    boxSizing: 'border-box',
    width: '8px',
    height: '8px',
    left: 'calc(50%)',
    top: 'calc(50% + 22px)',
    background: ({ pinIndex, colors }) => colors[(pinIndex) % colors.length],
    border: '1px solid white',
    borderRadius: '50%',
    margin: '0 auto',
  },
});
